import React from "react";
import { makeStyles, CardMedia, Box, Typography, Grid, Card, CardContent } from "@material-ui/core";
import PropTypes from "prop-types"

const useStyles = makeStyles({
    cardContent: {
        transition: 'transform 0.3s ease-in-out',
        '&:hover': {
            transform: 'scale(1.1)',
        },
    },
});

export default function OfficeResults(props) {
    const classes = useStyles();
    return (

        <Grid item xs={12}>

            <Card variant="outlined" className={classes.cardContent}
                sx={{ height: '100%', display: 'flex', flexDirection: 'column', cursor: 'pointer' }}
                onClick={() => props.onClick && props.onClick(props.item)}
            >
                <CardContent sx={{ flexGrow: 1 }}>
                    <Typography gutterBottom variant="h5" component="h2">
                        {props.item.title}
                    </Typography>
                    <Typography>
                        {props.item.spaceType}
                    </Typography>
                </CardContent>

                <Box sx={{ display: 'flex', gap: (30), alignItems: 'center', pl: 2, pb: 1 }}>
                    <Typography variant="h6">
                        {props.item.price}
                    </Typography>
                    <Typography variant="h6">
                        {props.item.displaySize || props.item.size}
                    </Typography>
                </Box>

                <CardContent sx={{ flexGrow: 1 }}>
                    <Typography>
                        <h4>Matching with the property: {props.item.matchingPercentage} </h4>
                    </Typography>
                </CardContent>

                <CardMedia
                    component="img"
                    sx={{
                        // 16:9
                        pt: '56.25%',
                    }}
                    image={props.item.imageSrc}
                />
            </Card>

        </Grid>

    );
}

OfficeResults.propTypes = {
    item: PropTypes.shape({
        title: PropTypes.string.isRequired,
        spaceType: PropTypes.string.isRequired,
        price: PropTypes.string,
        size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        displaySize: PropTypes.string,
        matchingPercentage: PropTypes.string,
        imageSrc: PropTypes.string.isRequired
    }).isRequired,
    onClick: PropTypes.func
}